namespace PortalLibs.Client.Components


open Fable.Core
open Fable.Core.JsInterop
open Fable.React
open Fable.React.Props
open System
open Elmish
open Fulma
open Fable.FontAwesome
open Feliz
open PortalLibs.Client.Util
open PortalLibs.Client.Components.DebouncedView
open FSharpPlus

module Datepicker =

  [<Import("default", from = "react-datepicker")>]
  let ReactDataPicker: obj = jsNative

  importAll "react-datepicker/dist/react-datepicker.css"

  let datePickerField name value dispatch =
    let props =
      createObj [
        "selected" => value
        "className" => "input"
        "onChange" => dispatch
        "preventOpenOnFocus" => true
      ]

    field name [ ofImport "default" "react-datepicker" props [] ]

  let monthPickerField value dispatch =
    let props =
      createObj [
        "selected" => value
        "className" => "input"
        "showMonthYearPicker" => true
        "dateFormat" => "MM/yyyy"
        "onChange" => dispatch
      ]

    ofImport "default" "react-datepicker" props []

  let datePickerInputWithPlaceholder placeHolder value dispatch =
    let props =
      createObj [
        "selected" => value
        "className" => "input"
        "onChange" => dispatch
        "placeholderText" => placeHolder
      ]

    ofImport "default" "react-datepicker" props []

module DatepickerBetween =

  let DatepickerBetween =
    React.memo<{| Key: string
                  Values: DateTime option * DateTime option
                  ValuesChanged: DateTime option * DateTime option -> unit |}> (
      name = "DatepickerBetween",
      areEqual = Helpers.equalsButFunctions,
      render =
        (fun props ->
          let fromValue, toValue = props.Values

          DebouncedView
            {| Key = $"DateBetweenDebouncedView-%s{props.Key}"
               Value = Some(fromValue, toValue)
               ValueChanged = (fun valuesOpt -> valuesOpt |> Option.iter props.ValuesChanged)
               Intercept =
                 Some
                   (fun values ->
                     let fromOpt, toOpt = values.Value

                     let prevFromValueOpt =
                       values.LastValue
                       >>= fst

                     let prevToValueOpt =
                       values.LastValue
                       >>= snd

                     let from =
                       match fromOpt, toOpt with
                       | Some fromValue, Some toValue ->
                         if prevToValueOpt <> toOpt && fromValue > toValue then
                           toOpt
                         else
                           fromOpt
                       | _ -> fromOpt

                     let toValue =
                       match fromOpt, toOpt with
                       | Some fromValue, Some toValue ->
                         if prevFromValueOpt <> fromOpt && fromValue > toValue then
                           fromOpt
                         else
                           toOpt
                       | _ -> toOpt

                     Some(from, toValue))
               View =
                 (fun datesOpt valueChanged ->
                   Control.div [ Control.Props [
                                   Style [
                                     Display DisplayOptions.Flex
                                     AlignItems AlignItemsOptions.Center
                                   ]
                                 ] ] [
                     Datepicker.datePickerInputWithPlaceholder
                       "From"
                       (datesOpt
                        >>= fst )
                       (fun dateFrom ->
                         Some(
                           dateFrom,
                           datesOpt
                           >>= snd
                         )
                         |> valueChanged)
                     Icon.icon [ Icon.Props [
                                   Style [ Color "gray"; Margin "0 5px" ]
                                 ] ] [
                       Fa.i [ Fa.Solid.Minus ] []
                     ]
                     Datepicker.datePickerInputWithPlaceholder
                       "To"
                       (datesOpt
                        >>= snd )
                       (fun dateTo ->
                         Some(
                           datesOpt
                           >>= fst ,
                           dateTo
                         )
                         |> valueChanged)
                   ]) |})
    )

  let viewWithHeader header props =
    field header [ DatepickerBetween props ]

module DatepickerMonth =

  let DatepickerMonth
    (props: {| Key: string
               Value: DateTime option
               ValueChanged: DateTime option -> unit |})
    =
    DebouncedView
      {| Key = $"DatepickerDebouncedView-%s{props.Key}"
         Value = props.Value
         ValueChanged = props.ValueChanged
         Intercept = None
         View = (fun valueOpt valueChanged -> Datepicker.monthPickerField valueOpt (fun month -> Some(month) |> valueChanged)) |}


  let viewWithHeader header props = field header [ DatepickerMonth props ]

module DatepickerDay =

  let DatepickerDay
    (props: {| Key: string
               Name: string
               Value: DateTime option
               ValueChanged: DateTime option -> unit |})
    =
    DebouncedView
      {| Key = $"DatepickerDayDebouncedView-%s{props.Key}"
         Value = props.Value
         ValueChanged = props.ValueChanged
         Intercept = None
         View =
           (fun valueOpt valueChanged -> Datepicker.datePickerField props.Name valueOpt (fun dt -> Some(dt) |> valueChanged)) |}


  let viewWithHeader header props = field header [ DatepickerDay props ]
